import { apiCall } from "./Interceptor";

const ENERGY_TYPE_ALL = "/energyType/getAll/public";
const ALL_REGIONS = "/region/getAll/public";
const ALL_VOLTAGE = "/voltageLevel/getAll/public";

const getAllEnegyType = async () => {
  const response = await apiCall.get(ENERGY_TYPE_ALL);
  return response;
};
const getAllRegions = async () => {
  const response = await apiCall.get(ALL_REGIONS);
  return response;
};
const getAllVoltage = async () => {
  const response = await apiCall.get(ALL_VOLTAGE);
  return response;
};

export default {
  getAllEnegyType,
  getAllRegions,
  getAllVoltage,
};
